import React from "react"

import Layout from "../components/layout"
import AboutMainArea from "../components/AboutMainArea"
import AboutPage from "../components/AboutPage"
import { graphql } from "gatsby"
// import Arrow from "../components/Arrow"
// import aboutImage from "../../static/img/benchmark.jpg"
import aboutImageTwo from "../../static/img/about-us-banner-hero-three.png"
import VisionMissionValues from "../components/VisionMissionValues"
import useWebsiteCmsContent from "../hooks/useWebsiteCmsContent"
import { localizedBlockData } from "../services/websiteCms"

export default function AboutUsTemplate({
  data: {
    markdownRemark: {
      frontmatter: { title, description, lang, image, ...restOfFrontmatter },
    },
  },
}) {
  const cmsPayload = useWebsiteCmsContent()
  const page = localizedBlockData(cmsPayload, "about-page", lang) || {}
  const active = { ...restOfFrontmatter, ...page }
  const activeTitle = page.title || title
  const activeDescription = page.description || description

  return (
    <Layout description={activeDescription} title={activeTitle} lang={lang}>
      <AboutMainArea
        image={aboutImageTwo}
        title={activeTitle}
      />
      <div className="b-homepage-content">
        <div className="b-layer-main">
          <VisionMissionValues
            vision={active.vision}
            mission={active.mission}
            values={active.values}
          />
          <AboutPage {...active} />
        </div>
      </div>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      frontmatter {
        title
        lang
        description
        weThinkAbout {
          title
          icon
          description
        }
        missions {
          title
          list {
            name
            title
            description
          }
        }
        vision {
          titleAr
          titleEn
          textAr
          textEn
        }
        mission {
          titleAr
          titleEn
          textAr
          textEn
        }
        values {
          titleAr
          titleEn
          itemsAr {
            title
            description
          }
          itemsEn {
            title
            description
          }
        }
        image {
          childImageSharp {
            fluid(maxWidth: 1800, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
        founderName
        founderRoles
        founderImage
        founderMessageTitle
        founderMessageText
      }
    }
  }
`
